// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"wl59x","revampedBreadCrumb":"_1aAC2"};